import React from 'react';
import SubContext from './SubContext';

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const SubSelector = () => {
  const ctx = React.useContext(SubContext);
  const setSelectedSub = ctx.setSelectedSub;
  const classes = useStyles();

  const handleSelect = React.useCallback(
    (event) => {
      if (!event.target.value) {
        return;
      }

      setSelectedSub(event.target.value);
    },
    [setSelectedSub]
  );

  return (
    <div>
      <FormControl color="secondary" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">
          Subscriber
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={ctx.selectedSub || ''}
          onChange={handleSelect}
          label="Subscriber"
        >
          {!ctx.selectedSub && <MenuItem value="" disabled />}
          {ctx.subs.map((sub, index) => (
            <MenuItem key={index} value={sub}>
              {sub}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default SubSelector;
